var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main",attrs:{"id":"main"},on:{"click":_vm.hideSidebars}},[_c('Categories'),_vm._v(" "),_c('Notice'),_vm._v(" "),_c('transition',{attrs:{"name":"page","mode":"out-in","appear":""}},[_c('router-view',{key:_vm.$route.params.id})],1)],1)],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-219cb60f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/layouts/full.vue
// module id = 8ZVd
// module chunks = 53